import { render, staticRenderFns } from "./ContestActivitySectionComponent.vue?vue&type=template&id=bb7166e2"
import script from "./ContestActivitySectionComponent.vue?vue&type=script&lang=js"
export * from "./ContestActivitySectionComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestActivitySectionComponent.vue?vue&type=style&index=0&id=bb7166e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports